module.exports = __webpack_public_path__ + "img/icon-web-home-tit.5c25a85b.png";